import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {RoomParty} from '../../graphql/groups.datatypes';

enum Trashed {
    WITH = "WITH",
    WITHOUT = "WITHOUT"
}

interface RoomPartyData {
    roomParty: RoomParty
}

export const gqlRoomParty = `
    id
    group_booking_id
    hotel_resource_id
    disabled
    start_date
    end_date
    wheelchair_access
    has_infants
    notes
    hasRoomResource
    members_different_dates

    booking {
      id
      created_at
      group_id

      billingParties {
        id
        code

        payingMembers {
            id
            email
            primary_paying_member
            first_name
            last_name
        }
      }

      group {
        id
        name
        tour_resource_id
        hotel_resource_id
        start_date
        end_date
        max_additional_nights
        booking_form_url
        description_checkin

        tour {
            id
            internal_name
            display_name
        }

        members {
            id
            first_name
            last_name

            roomMember {
                id
                billing_party_id
            }
        }
      }
    }

    hotel {
        id
        internal_name
        display_name

        roomResources {
            id
            internal_name
            guest_capacity
            allow_manual_overbooking

            resource_banks {
                id
                remaining
                date
            }
        }
    }

    options {
        id
        room_party_id
        group_resource_option_id
        unit_count
        unit_cost
        admin_edited

        groupResourceOption {
            id

            option {
                id
                internal_name
            }
        }
    }

    members {
        id
        room_party_id
        group_member_id
        billing_party_id
        primary_occupant
        guest_number
        start_date
        end_date
        cost
        totalPayments
        outstandingBalance
        hasVaryingDates

        groupMember {
            id
            group_id
            user_id
            first_name
            last_name
            email
            cellphone_code
            cellphone
            dob
            group_role
            validated
            cancelled
            disabled
            authorised
            ageAtEvent

            group {
                id
                name
            }

            documents {
                id
            }
        }

        billingParty {
            id

            payingMembers {
                id
                email
                primary_paying_member
            }
        }

        options(trashed: WITH) {
            id
            group_resource_option_id
            unit_count
            unit_cost
            admin_edited
            deleted_at

            groupResourceOption {
                id

                option {
                    id
                    internal_name
                }
            }
        }
    }

    roomResource {
        id

        resource {
            id
            guest_capacity
        }
    }
`;

export const GET_ROOM_PARTY_QUERY = gql`
    query roomParty($id: Int!, $trashed: Trashed!){
        roomParty(id: $id, trashed: $trashed){
          ${gqlRoomParty}
        }
    }
`;

export const getRoomParty = (partyId: number | null, withTrashed?: Boolean) => {
    const id = partyId ? partyId : -1;
    const trashed = withTrashed ? Trashed.WITH : Trashed.WITHOUT;
    return useQuery<RoomPartyData>(
        GET_ROOM_PARTY_QUERY,
        {
            variables: {id, trashed},
        }
    );
};

export default getRoomParty;
